module.exports = __webpack_public_path__ + "assets/7702e4777ca387997468b1253197b1ec.mp3";